module.exports = __webpack_public_path__ + "static/media/needimg1.b146863d.jpg";